export class PartnerSystem {
        Id: number;
        Name: string;
        Key: string;
    }